export const MessageType = {
  AUDIO: 'AUDIO',
  TRANSCRIPT: 'TRANSCRIPT',
  HEARTBEAT: 'HEARTBEAT',
  METADATA: 'METADATA',
};

export const LanguageCode = {
  ZUL: 'zul',
  ENG: 'eng',
  AFR: 'afr',
  NSO: 'nso',
  TSN: 'tsn',
  SOT: 'sot',
  XHO: 'xho',
  VEN: 'ven',
  TSO: 'tso',
  SSW: 'ssw',
  NBL: 'nbl',
};

export const ConnectionState = {
  DISCONNECTED: 'disconnected',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  RECONNECTING: 'reconnecting',
  FAILED: 'failed',
};